



































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';

import SaveBtnGroup from '@/components/Common/SaveBtnGroup.vue';
import ContactNumberLabel from '@/components/Common/ContactNumberLabel.vue';
import { UserModule } from '@/store/modules/user';
import { TagsViewModule } from '@/store/modules/tags-view';
import { ContactPerson } from '@/interface/companySetting';
import { getPhoneRegionsApi } from '@/api/student-management';
import { hasChinese, checkEmail2 } from '@/utils/validate';
import {
  addGearUserApi,
  editGearUserApi,
  getAgentInfoApi,
  getDefaultRoleListApi,
  getGearUserInfoByIdApi,
  checkGearUserByMobileOrEmailApi,
  getExistAccountCommissionEmailApi,
} from '@/api/company';

@Component({
  name: 'contactPerson',
  components: {
    SaveBtnGroup,
    ContactNumberLabel
  }
})
export default class extends Vue {

  get isSetCommissionEmail() {
    if (['CONTACT_AGENT_VP','CONTACT_AGENT_FINANCE'].includes(this.formData.fkContactPersonTypeKey) && this.noComissionContractTips) {
      return true;
    }
    return false;
  }

  public pageType: string = 'add';
  public typeKeyOptions: any = [];
  public regionNumOptions: any = [];
  public contactAddress = '';
  public messagingSoftware1 = ['QQ', 'WeChat', 'Line'];
  public messagingSoftware2 = ['WhatsApp', 'Viber', 'Zalo']
  public noComissionContractTips: string = '';
  public formData: ContactPerson = {
    fkContactPersonTypeKey: '',
    name: '',
    // company: '',
    department: '',
    title: '',
    birthday: '',
    gender: '',
    isCommissionEmail: '',
    isNewsEmail: true,
    email: '',
    mobileAreaCode: '',
    mobile: '',
    telAreaCode: '',
    tel: '',
    qq: '',
    whatsapp: '',
    wechat: '',
    contactAddress: '',
    remark: '',
    id: '',
    isIdentityChecked: true,
    messagingSoftwareOneAccount: '',
    messagingSoftwareTypeOne: '',
    messagingSoftwareTwoAccount: '',
    messagingSoftwareTypeTwo: '',
    messagingSoftwareTypeOneAreaCode: '',
    messagingSoftwareTypeTwoAreaCode: '',
  };

  public formRules = {
    fkContactPersonTypeKey: [
      { required: true, validator: this.checkIsEmpty, trigger: 'change' }
    ],
    name: [
      { required: true, validator: this.checkIsEmpty, trigger: 'blur' }
    ],
    gender: [
      { required: true, validator: this.checkIsEmpty, trigger: 'change' }
    ],
    company: [
      { required: true, validator: this.checkIsEmpty, trigger: 'blur' }
    ],
    isCommissionEmail: [
      { required: true, validator: this.checkIsEmpty, trigger: 'change' }
    ],
    isNewsEmail: [
      { required: true, validator: this.checkIsEmpty, trigger: 'change' }
    ],
    department: [
      { required: true, validator: this.checkIsEmpty, trigger: 'blur' }
    ],
    title: [
      { required: true, validator: this.checkIsEmpty, trigger: 'blur' }
    ],
    email: [
      { required: true, validator: this.checkIsEmpty, trigger: 'blur' },
      { validator: this.rulesEmail, trigger: ['blur', 'change'] },
      { validator: this.checkHasChinese, trigger: 'blur' },
    ],
    mobile: [
      { required: true, validator: this.checkIsEmpty, trigger: 'blur' },
      { validator: this.checkPhoneNumber, trigger: 'blur' },
    ],
    mobileAreaCode: [
      { required: true, validator: this.checkIsEmpty, trigger: 'change' },
      { validator: this.checkPhoneRegion, trigger: 'change' },
    ],
  }

  public checkIsEmpty(rule: any, value: string, callback: any) {
    let val;
    if (typeof value === 'string') {
      val = typeof value === 'string' ? value.trim() : value;
    } else if (typeof value === 'number') {
      val = Number(value);
    } else {
      val = value;
    }
    if ((val === '' || val === undefined || val === null)) {
      callback(new Error(this.$t('validate.requiredField') as string));
    } else {
      callback();
    }
  }

  public checkPhoneNumber(rule: any, value: string, callback: any) {
    const mobileAreaCode = this.formData.mobileAreaCode;
    if (!mobileAreaCode) { return callback() };
    if (!this.phoneRegionValidate(mobileAreaCode, value)) {
      callback(new Error(this.$t('validate.phoneRegionValid') as string));
    } else {
      const formRef = this.$refs.formRef as any;
      formRef.clearValidate('mobileAreaCode');
      callback();
    }
  }

  public checkPhoneRegion(rule: any, value: string, callback: any) {
    const mobile = this.formData.mobile;
    if (!mobile) { return callback() };
    const formRef = this.$refs.formRef as any;
    if (!this.phoneRegionValidate(value, mobile)) {
      formRef.validateField('mobile', callback(this.$t('validate.phoneRegionValid') as string));
      callback();
    } else {
      formRef.clearValidate('mobile');
      callback();
    }
  }

  public phoneRegionValidate(region: string, phone: string) {
    let phoneReg: RegExp | null = null;
    switch (region) {
      case '86': // 中国大陆：开头1 3-8号段，后边跟9位数字
        phoneReg = /^[1][3,4,5,7,8,9,6][0-9]{9}$/;
        break;
      case '852': // 5或9或6开头后面跟7位数字
        // phoneReg = /^([4|5|6|7|9])\d{7}$/;
        phoneReg = /^\d{8}$/;
        break;
      case '853': // 6开头后面跟7位数字
        phoneReg = /^[6]\d{7}$/;
        break;
      case '886': // 9(或09)开头后面跟8位数字
        phoneReg = /^([0]?[9])\d{8}$/;
        break;
      case '61': // 澳大利亚4(或04)开头, 后面跟8位数
        phoneReg = /^([0]?[4])\d{8}$/;
        break;
      case '44': // 英国电话号码是7(或07)开头的, 后面跟9位数
        phoneReg = /^([0]?[7])\d{9}/;
        break;
    }
    if (phoneReg) {
      return phoneReg.test(phone);
    }
    return true;
  }

  // 验证邮箱（多个邮箱）
  public  rulesEmail(rule: any, value: string, callback: any) {
    if (checkEmail2(value)) {
      callback();
    } else {
      callback(new Error(this.$t('validate.emailValid') as string));
    }
  }

  public checkHasChinese(rule: any, value: string, callback: any) {
    if (value && hasChinese(value)) {
      callback(new Error(this.$t('validate.englishNameValid') as string));
    } else {
      callback();
    }
  }

  public created() {
    const { id } = this.$route.params;
    if (id && !isNaN(Number(id))) {
      this.pageType = 'edit';
      this.getContactPersonDetail(Number(id));
    }
    this.getAgentInfo();
    this.getTypeKeyOptions();
    this.getPhoneRegionOptions();
    this.getExistAccountCommissionEmail();
  }

  public async getExistAccountCommissionEmail(fkUserId?: number | string) {
    try {
      const params = {
        fkAgentId: UserModule.fkAgentId,
        fkUserId
      }
      const { data } = await getExistAccountCommissionEmailApi(params);
      if (data.message) {
        this.noComissionContractTips = data.message;
      }
    } catch (error) {
      console.log(error);
    }
  }

  public async getAgentInfo() {
    const { data } = await getAgentInfoApi();
    const { countryName, stateName, cityName, address, name } = data.data;
    this.contactAddress = `${countryName ?countryName + ', ' : ''}${stateName ? stateName + ', ' : ''}${cityName ? cityName + ', ' : ''}${address? address : ''} (${name})`;
  }

  public handleRoleTypeChange(value: string) {
    if (this.isSetCommissionEmail) {
      this.formData.isCommissionEmail = true;
    } else {
      this.formData.isCommissionEmail = '';
    }
    if (value === "CONTACT_AGENT_SALES") {
      this.formData.isCommissionEmail = false;
    }
  }

  public async handleCommissionEmailChange() {
    try {
      const id = this.formData.id;
      if (this.formData.isCommissionEmail === false && id) {
        await this.getExistAccountCommissionEmail(id);
        if (this.noComissionContractTips) {
          this.$message({
            type: 'warning',
            message: this.$t('company.isSetCommissionEmailTips') as string,
            duration: 10000
          });
          this.formData.isCommissionEmail = true;
          this.noComissionContractTips = '';
        }
      }
    } catch (error) {
      //
    }
  }

  public async handleMobileChange(value: string) {
    if (!this.formData.mobileAreaCode) {
      return this.$message.warning(this.$t('login.mobileAreaCodeMsg') as string);
    }
    const submitBtnRef = this.$refs.saveBtnRef as any;
    try {
      submitBtnRef.disabledTrue();
      await checkGearUserByMobileOrEmailApi({ mobile: value, mobileAreaCode: this.formData.mobileAreaCode });
    } finally {
      submitBtnRef.disabledFalse();
    }
  }

  public async handleEmailChange(value: string) {
    const submitBtnRef = this.$refs.saveBtnRef as any;
    try {
      submitBtnRef.disabledTrue();
      await checkGearUserByMobileOrEmailApi({ email: value });
    } finally {
      submitBtnRef.disabledFalse();
    }
  }

  public async getTypeKeyOptions() {
    const { data } = await getDefaultRoleListApi();
    this.typeKeyOptions = data.datas;
  }

  public async getPhoneRegionOptions() {
    const { data } = await getPhoneRegionsApi();
    this.regionNumOptions = data.datas;
  }

  public async getContactPersonDetail(id: number) {
    const { data } = await getGearUserInfoByIdApi(id);
    this.formData = Object.assign(this.formData, data.data);
  }

  public save() {
    const formRef = this.$refs.formRef as any;
    formRef.validate((valid: boolean) => {
      if (valid) {
        if (this.pageType === 'add') {
          this.add();
        } else {
          this.edit();
        }
      }
    });
  }

  public async add() {
    const submitBtnRef = this.$refs.saveBtnRef as any;
    submitBtnRef.loadingTrue();
    try {
      const fkTableId = UserModule.fkAgentId;
      this.formData = Object.assign(this.formData, { fkTableName: 'm_agent', fkTableId });
      await addGearUserApi(this.formData);
      this.$message.success(this.$t('message.addSuccess') as string);
      this.cancel();
    } finally {
      submitBtnRef.loadingFalse();
    }
  }

  public async edit() {
    const submitBtnRef = this.$refs.saveBtnRef as any;
    submitBtnRef.loadingTrue();
    try {
      await editGearUserApi(this.formData);
      this.$message.success(this.$t('message.editSuccess') as string);
      this.cancel()
    } finally {
      submitBtnRef.loadingFalse();
    }
  }

  public cancel() {
    this.$router.push({ name: 'setting' });
    TagsViewModule.delView(this.$route); // 删除当前路由
  }
}
